export const PRO_REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';
export const PRO_REGISTRATION_ERROR = 'REGISTRATION_ERROR';
